module.exports = __webpack_public_path__ + "static/media/grafico-unicred-centro-sul-6.dd967487.png";